import axiosInstance from '../services/axiosInstance';
import { envUrls } from './env';

// Uncomment this to test localhost
// envUrls.scansService = 'http://localhost:3005/scans/';

export default class ScanDetails {
  async createScan(payload) {
    return await axiosInstance
      .post(`${envUrls.scansService}create_scan`, payload, {
        headers: {
          appName: 'bluescout',
        },
      })
      .then((response) => response.data)
      .catch((err) => console.log(err));
  }

  async createScanVersion(payload) {
    return await axiosInstance
      .patch(`${envUrls.scansService}create_version`, payload, {
        headers: {
          appName: 'bluescout',
        },
      })
      .then((response) => response.data)
      .catch((err) => console.log(err));
  }

  async loadNewScanDetails(id) {
    return await axiosInstance
      .get(`${envUrls.scansService}get_scan_details`, {
        params: {
          version_id: id,
        },
        headers: {
          appName: 'bluescout',
        },
      })
      .then((response) => response.data)
      .catch((err) => console.log(err));
  }

  async loadUserScans(payload) {
    return await axiosInstance
      .get(`${envUrls.scansService}get_user_scans`, {
        params: {
          user_id: payload,
        },
        headers: {
          appName: 'bluescout',
        },
      })
      .then((response) => response.data)
      .catch((err) => console.log(err));
  }

  async deleteScan(payload) {
    return await axiosInstance
      .delete(`${envUrls.scansService}delete_scan`, {
        params: {
          scan_id: payload,
        },
        headers: {
          appName: 'bluescout',
        },
      })
      .then((response) => response.data)
      .catch((err) => console.log(err));
  }

  async shareUserScans(payload) {
    return await axiosInstance
      .post(`${envUrls.scansService}add_share`, payload, {
        headers: {
          appName: 'bluescout',
        },
      })
      .then((response) => response.data)
      .catch((err) => console.log(err));
  }

  async updateScanVersionCounts(payload) {
    return await axiosInstance
      .patch(`${envUrls.scansService}update_scan_version_counts`, payload, {
        headers: {
          appName: 'bluescout',
        },
      })
      .then((response) => response.data)
      .catch((err) => console.log(err));
  }

  async computeUserScanMetrics(payload) {
    return await axiosInstance
      .post(`${envUrls.scansService}compute_user_scan_metrics`, payload, {
        headers: {
          appName: 'bluescout',
        },
      })
      .then((response) => response.data)
      .catch((err) => console.log(err));
  }

  async updateScanName(payload) {
    return await axiosInstance
      .patch(`${envUrls.scansService}update_scan_name`, payload, {
        headers: {
          appName: 'bluescout',
        },
      })
      .then((response) => response.data)
      .catch((err) => console.log(err));
  }

  async updateFilterSetDocCount(payload) {
    return await axiosInstance
      .patch(`${envUrls.scansService}update_filter_set_doc_count`, payload, {
        headers: {
          appName: 'bluescout',
        },
      })
      .then((response) => response.data)
      .catch((err) => console.log(err));
  }

  async pinUnpinRenameFilterSet(payload) {
    return await axiosInstance
      .patch(`${envUrls.scansService}pin_unpin_rename_filter_set`, payload, {
        headers: {
          appName: 'bluescout',
        },
      })
      .then((response) => response.data)
      .catch((err) => console.log(err));
  }

  providePdfUploadUrlObject() {
    // Provide scan service url packaged in an object to be used by the :factory property of the q-uploader for semantic search pdf file uploads
    return {
      url: `${envUrls.scansService}semantic/pdf`,
      method: 'POST',
    };
  }
}
